/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

const constants = require('@utils/_constants');

/**
 * FiltersService is responsible for shared filters functionality
 *
 * @module enervee_utils.filters
 */
FiltersService.$inject = [
    '$q',
    '$state',
    '$stateParams',
    '$log',
    '$filter',
    '$location',
    'CategoriesService',
    'CmsContentService',
    'GetFetchService',
    'ProductApiConsumerService',
    'UserApiConsumerService',
    'UtilService',
    'SwiftypeService',
    'AnalyticsService',
    'FiltersSortByService',
    'CATEGORY_FACETS',
];
function FiltersService(
    $q,
    $state,
    $stateParams,
    $log,
    $filter,
    $location,
    CategoriesService,
    CmsContentService,
    GetFetchService,
    ProductApiConsumerService,
    UserApiConsumerService,
    UtilService,
    SwiftypeService,
    AnalyticsService,
    FiltersSortByService,
    CATEGORY_FACETS,
) {

    let _pub = {
            isDefaultFilterSelected: isDefaultFilterSelected,
            checkFilterAutoToggles: checkFilterAutoToggles
        },
        _categoryFilters = null,
        _translatedCategoryFilters = {},
        _initialSwiftypeFacets = null,
        noMinText = '',
        noMaxText = '';

    _pub.defaultFilterSettings = UtilService.getSiteSetting(
        'default_filters',
        [
            {
                code: "is_latest_models",
                urlValue: "is-latest-models",
                categoryCode: "cars",
                selectedValue: "yes",
                unselectedValue: "no",
                options: [
                    {
                        display_name: "Latest Model",
                        url_value: "yes",
                        is_checked: true
                    }
                ]
            }
        ]
    );

    _pub.filterAutoToggles = UtilService.getSiteSetting(
        'filter_auto_toggles',
        [
            {
                watch_url_value: "is-latest-models",
                reset_filter_code: "model_year"
            },
            {
                watch_url_value: "model-year",
                reset_filter_code: "is_latest_models"
            }
        ]
    );

    _pub.isNewFiltersEnabled = UtilService.isFeatureEnabled("new_filters_enabled");
    _pub.lockFilters = _pub.isNewFiltersEnabled && UtilService.isMobile();

    CmsContentService.getMarketPlaceText('filters:range_no_min').then(function(text){
        noMinText = text;
        CmsContentService.getMarketPlaceText('filters:range_no_max').then(function(text){
            noMaxText = text;
        });
    });

    /**
     * The results of all filters
     *
     * @type {{}}
     */
    var allFiltersOutputsJson = {};

    /**
     * The list of all filter result callback functions to call one by one and get all filter results
     *
     * @type {Array}
     */
    _pub.filtersOutputCallbacks = [];

    /**
     * The list of all filter reset callback functions to call one by one and get reset all filters
     *
     * @type {Array}
     */
    _pub.filtersResetCallbacks = [];

    /**
     * This callback is defined inside the resultsController scope. We can call this function and pass in an integer
     * to set the number of results in the resultsController scope
     *
     * @type {Function}
     */
    _pub.updateResultsQuantity = null;
    _pub.onResultsQuantityUpdated = function (callback) {
        _pub.updateResultsQuantity = callback;
    };

    /**
     * Registers on mobile filter changed callbacks and invokes the callbacks using runMobileFilterChangedCallbacks
     * when a mobile filter is changed
     *
     * @type {Array.Function}
     */
    _pub.mobileFilterChangedCallbacks = [];
    _pub.onMobileFilterChanged = (callback) => {
        if (typeof callback === "function") {
            _pub.mobileFilterChangedCallbacks.push(callback);
        }
    };

    const runMobileFilterChangedCallbacks = () => {
        const requestOptions = getSwiftypeSearchRequestOptions();
        _pub.mobileFilterChangedCallbacks.forEach((callback) => callback(requestOptions));
    };

    /**
     * The mapping object of all unselected default filters
     *
     * @type {Object}
     */
    _pub.unselectedDefaultFilters = {};

    _pub.activateCategory = function() {
        _pub.activeCategory = CategoriesService.getActiveCategory();
    };

    _pub.activateCategory();

    _pub.getFilterInputType = getFilterInputType;

    //Segment tracking functions
    _pub.trackProductFiltersEngaged = trackProductFiltersEngaged;
    _pub.trackCollapsedFiltersEngaged = trackCollapsedFiltersEngaged;

    _pub.closeMobileFilters = closeMobileFilters;

    /**
     * Gets the filter details object and determines whether or not the filter should be rendered as a checkbox
     *
     * @param details {Object}: Filter object
     * @returns {boolean} Whether or not the give filter should be rendered as a checkbox filter
     */
    _pub.isCheckboxFilter = (details) => {
        const checkboxFilterTypes = ['textbox_dropdown', 'checkboxes', 'textbox', 'dropdown_checkboxes'];
        return checkboxFilterTypes.includes(_pub.getFilterInputType(details));
    };

    /**
     * Gets rid of filters in filtersJson that have `null` as its value
     * so that `createLink` doesn't create a query param for filters that have no value
     *
     * @param filtersJson
     * @private
     */
    var _cleanOffNullValues = function (filtersJson) {
        var filterValue;
        for (var filter in filtersJson) {
            filterValue = filtersJson[filter];
            if (filterValue === null) {
                delete filtersJson[filter];
            }
        }
    };

    /**
     * Creates a link containing the filters as get parameters
     *
     * @param filtersJson
     * @returns {string}
     */
    _pub.createLink = function(filtersJson) {
        var link = [];
        var filterValue;


        for (var filter in filtersJson) {
            filterValue = filtersJson[filter];
            if (Array.isArray(filterValue)) {
                for(var filterArrayIndex in filterValue) {
                    if (typeof(filterValue[filterArrayIndex]) === 'object') {
                        _objectToQueryset(link, filter, filterValue[filterArrayIndex]);
                    } else {
                        _itemsToQueryset(link, filter, filterValue[filterArrayIndex]);
                    }
                }
            } else {
                if (typeof(filterValue) === 'object') {
                    _objectToQueryset(link, filter, filterValue);
                } else {
                    _itemsToQueryset(link, filter, filterValue);
                }
            }
        }

        return link.join("&");
    };

    /**
     * takes a GET param link and parses it into a dictionary.
     *
     * @param link
     * @returns {{}}
     */
    _pub.linkToDict = function(link){
        var dict = {};
        var pairs = link.split('&');
        var key;
        var val;

        pairs.forEach(function(pair){
            key = decodeURIComponent(pair.split('=')[0]);
            val = decodeURIComponent(pair.split('=')[1]);

            if (key in dict) {
                if (!Array.isArray(dict[key])) {
                    // convert repeated key to array
                    dict[key] = [dict[key]];
                }
                dict[key].push(val);
            } else {
                // add simple key-value pair
                dict[key] = val;
            }
        });
        return dict;
    };

    /**
    * Helper to create query string from json
    *
    * @param filter_list {array}
    * @param filter {string}
    * @param value {string}
    */
    var _itemsToQueryset = function(filter_list, filter, value){
        filter_list.push([encodeURIComponent(filter), encodeURIComponent(value)].join("="));
    };

    /**
     * Helper to create query string from json range object
     *
     * @param filter_list {array} - list of filters to add to
     * @param filter {string} - current filter to encode
     * @param value {string} - filter value
     */
    var _objectToQueryset = function(filter_list, filter, value) {
        if (value.hasOwnProperty('min')) {
            filter_list.push([encodeURIComponent('min-' + filter), encodeURIComponent(value.min)].join("="));
        }
        if (value.hasOwnProperty('max')) {
            filter_list.push([encodeURIComponent('max-' + filter), encodeURIComponent(value.max)].join("="));
        }
    };

    /**
     * Takes a range value that has been URL encoded and breaks it into
     * an object that Swiftype understands.
     * example:
     *    300-500 becomes {type: 'range', from: 300, to: 500}
     *
     * @param rangeValues - the url encoded range
     * @returns {{}} - an object that Swiftype understand for filtering by a range
     */
    _pub.convertRangeValueToSwiftype = function(key, filters) {
        var swiftypeDict = {type: 'range'};
        Object.keys(filters).forEach(function (filter) {
            if (filter.toLowerCase().indexOf(key) > -1) {
                if (filter.toLowerCase().indexOf('min-') > -1) {
                    swiftypeDict.from = filters[filter][0];
                } else if (filter.toLowerCase().indexOf('max-') > -1) {
                    swiftypeDict.to = filters[filter][0];
                } else {
                    var fromTo = filters[filter][0].split('-');
                    if (fromTo[0] !== 'null') {
                        swiftypeDict.from = fromTo[0];
                    }
                    if (fromTo[1] !== 'null') {
                        swiftypeDict.to = fromTo[1];
                    }
                }
            }
        });

        return swiftypeDict;
    };

    _pub.convertValueToSwiftype = function (filterValue, facet) {
        var swiftypeValue = [];
        filterValue.forEach(function (value) {
            var urlizedValue = value.toLowerCase().replace(' ', '-');
            facet.values.forEach(function (option) {
                if (option.url_value === urlizedValue) {
                    swiftypeValue.push(option.display_name);
                }
            });
        });
        return swiftypeValue;
    };

    /**
     * Filters results based on the selected/entered filters.
     * For filters in the top bar (price, etc.), the final value is selected
     * based on `topFiltersChanged`, since there will be duplicate filterOutput
     * callbacks for those filters.
     *
     * @param {Boolean} [topFiltersChanged=false]
     */
    _pub.filterResults = function (topFiltersChanged=false) {

        allFiltersOutputsJson = {};

        _pub.filtersOutputCallbacks.forEach(function (filterOutput) {
            const output = filterOutput.filter_output();
            const filterKey = Object.keys(output).pop();
            const filterKeyIsNew = !allFiltersOutputsJson.hasOwnProperty(filterKey);

            if (filterKeyIsNew || topFiltersChanged === filterOutput.is_top_menu_item) {
                allFiltersOutputsJson = angular.extend({}, allFiltersOutputsJson, output);
            }
        });

        _cleanOffNullValues(allFiltersOutputsJson);
        _pub.selectedFiltersData = Object.assign({}, allFiltersOutputsJson);

        Object.keys(allFiltersOutputsJson).forEach(function(filterName){
            if (!(filterName in _translatedCategoryFilters)){
                fetchTranslatedFilterCodes(filterName).then(function(translatedFilter){
                    if (translatedFilter === ""){
                        _translatedCategoryFilters[filterName] = filterName;
                    } else {
                        _translatedCategoryFilters[translatedFilter] = filterName;
                    }
                });
            }
        });

        var translatedFiltersOutputsJson = {};
        Object.keys(allFiltersOutputsJson).forEach(function(filter){
            var translatedFilter = UtilService.getKeyByValue(_translatedCategoryFilters, filter);
            if (translatedFilter !== null) {
                translatedFiltersOutputsJson[translatedFilter] = allFiltersOutputsJson[filter];
            } else {
                translatedFiltersOutputsJson[filter] = allFiltersOutputsJson[filter];
            }
        });

        var link = _pub.createLink(translatedFiltersOutputsJson);
        var options = {"category_code": _pub.activeCategory.category_code};
        options[_translatedCategoryFilters.text] = link;

        // If the buying guide was set to open, ensure it's not opened a second time
        if ($stateParams.guide) {
            options.guide = null;
        }

        let reloadOptions;
        if (_pub.isNewFiltersEnabled && UtilService.isMobile()) {
            options[FiltersSortByService.translatedSortByKey] = FiltersSortByService.getActiveSortByOption();
            reloadOptions = {notify: false};
        } else {
            _pub.filtersOutputCallbacks = [];
            reloadOptions = {reload: true};
        }

        $state.go('results.filtered', options, reloadOptions);
    };

    _pub.currentFilters = function() {
        var _filtersData = {};
        _filtersData.categoryId = CategoriesService.getCategoryIdByCode($state.params.category_code);
        var languageCode = UtilService.getSetting('languageCode');
        var paramsNames = constants.RESULTS_QUERY_PARAMS[languageCode] || constants.RESULTS_QUERY_PARAMS.en_EN;
        var filtersKey = paramsNames.filtersParamsName;
        if ($state.params[filtersKey]) {  // This code needs to dynamically get the "filters" key based on site language
            var url_filters = _pub.linkToDict($state.params[filtersKey]);
            for (var key in url_filters){
                _filtersData[key] = url_filters[key];
            }
        }
        return _filtersData;
    };

    _pub.saveSearch = function () {
        var _filtersData = {};
        _filtersData.name = "default";
        _filtersData.filters = Object.assign({}, _pub.currentFilters());
        _filtersData.filters.categoryId = CategoriesService.getCategoryIdByCode($state.params.category_code);
        _filtersData.sort_order = '-user_reviews';
        return UserApiConsumerService.post('/api/1.0/user-profile/saved-search/', _filtersData).then((response) => {
            GetFetchService.clear('user-profile-saved-searches');
            // Also clear the endpoint where we get saved search counts from
            GetFetchService.clear('profile-info');
            return response;
        });
    };

    /**
     * applies reset callbacks and clears the callbacks
     *
     */
    _pub.applyResetCallbacks = function () {

        _pub.filtersResetCallbacks.forEach(function (filterReset) {
            filterReset.callback(null);
        });
        _pub.filtersResetCallbacks = [];
        _pub.filtersOutputCallbacks = [];
        allFiltersOutputsJson = {};
        _pub.selectedFiltersData = {};
    };

    /**
     * Resets specific filter
     */
    _pub.resetFilter = function (filterCode, valueToRemove) {
        valueToRemove = valueToRemove || null;
        _pub.filtersResetCallbacks.forEach(function(filterReset) {
            if (filterReset.filterKey === filterCode) {
                filterReset.callback(valueToRemove);
            }
        });

        if (_pub.isNewFiltersEnabled && UtilService.isMobile()) {
            runMobileFilterChangedCallbacks();
        } else {
            _pub.filterResults();
        }
    };

    /**
     * resets all filters
     *
     */
    _pub.resetFilters = function() {
        _pub.applyResetCallbacks();
        _pub.selectedFiltersData = allFiltersOutputsJson;
        var link = _pub.createLink({});
        const unselectedDefaultFilters = getUnselectedDefaultFilters();
        $location.search('filters', unselectedDefaultFilters);
        var options = {"category_code": _pub.activeCategory.category_code};
        if (link) {
            options[_translatedCategoryFilters.text] = link;
        }
        $state.go('results', options, {reload: true});
    };

    /**
     * Sets initial filters to swiftype style filters from routings.
     * example:
     * {
     *     'query': ['banana'],
     *     'price': {'type': 'range',
     *               'from': 300,
     *               'to': 500},
     *     'brand': ['Samsung', 'GE']
     * }
     * @param filters
     */
    _pub.setFiltersInitialData = function(filters){
        _pub.initialFiltersData = filters;
        if (UtilService.isMobile()) {
            setTimeout(() => {
                _pub.getResultsQuantity();
            });
        }
    };


    /**
     * Cleans category filters
     *
     * @param categoryFilters
     * @returns {*}
     * @private
     */
    var _cleanFilters = function (categoryFilters) {

        if (categoryFilters.top_menu) {
            categoryFilters.top_menu.forEach(function (filter) {
                if (filter.type === "checkboxes") {
                    filter.type = "dropdown_checkboxes";
                }
            });
        }

        return categoryFilters;
    };


    /**
     * fetches category filters
     *
     * @param categoryId
     * @returns {*}
     */
    _pub.fetchCategoryFilters = function (categoryId) {

        return ProductApiConsumerService.get('api/1.0/category-filters/' + categoryId + '/').then(function(result){
            var categoryFilters = result.data;
            _categoryFilters = _cleanFilters(categoryFilters);
        });

    };


    /**
     * gets category filters
     *
     * @returns {*}
     */
    _pub.getCategoryFilters = function () {

        return _categoryFilters;

    };

    var fetchTranslatedFilterCodes = function (filterName) {
        var defer = $q.defer();

        CmsContentService.getMarketPlaceText('filters:url:' + filterName).then(function(text){
            defer.resolve(text);
        });

        return defer.promise;
    };

    _pub.getTranslatedFilterCodes = function (filtersToTranslate) {
        filtersToTranslate = filtersToTranslate || [];
        var defer = $q.defer(),
        translatedFilterCodesPromises = [],
        promise = null;
        CmsContentService.retrieveCMSContent('filters');

        filtersToTranslate.forEach(function(filter){
            if (!(filter in _translatedCategoryFilters)){
                promise = fetchTranslatedFilterCodes(filter).then(function(translatedFilter){
                    if (translatedFilter === "") {
                        translatedFilter = filter;
                    }
                    if (filter === 'text'){
                        _translatedCategoryFilters[filter] = translatedFilter;
                    } else {
                        _translatedCategoryFilters[translatedFilter] = filter;
                    }
                });
                translatedFilterCodesPromises.push(promise);
            }
        });
        $q.all(translatedFilterCodesPromises).then(function() {
            defer.resolve(_translatedCategoryFilters);
        });
        return defer.promise;
    };

    /**
     * Gets facets from Swiftype for current category.
     * @param categoryCode
     */
    _pub.getInitialSwiftypeFacets = function(categoryCode) {
        if (CATEGORY_FACETS.hasOwnProperty(categoryCode)) {
            const facets = CATEGORY_FACETS[categoryCode];
            _initialSwiftypeFacets = facets;
            return $q.resolve(_initialSwiftypeFacets);
        } else {
            return getInitialFacetsFromBackend(categoryCode);
        }
    };

    /**
     * Gets facets from search endpoint if facets weren't retrieved in server.
     * @param {String} categoryCode 
     */
    function getInitialFacetsFromBackend (categoryCode) {
        const defer = $q.defer();
        const facetsUrl = ProductApiConsumerService.getFullUrl('/api/1.0/swiftype/search/');

        const options = {
            'filters': {},
            'document_types': [categoryCode],
            'per_page': 18
        };
    
        const swiftypeFilters = UtilService.getSiteSetting('default_swiftype_filters', {});
        if (!options.filters.hasOwnProperty(categoryCode) && swiftypeFilters.hasOwnProperty(categoryCode)) {
            options.filters[categoryCode] = {};
            options.filters[categoryCode] = angular.extend(options.filters[categoryCode], swiftypeFilters[categoryCode]);
        }

        const data = {
            'url': facetsUrl,
            'data': options,
            'method': 'POST'
        };

        GetFetchService.get(['initialSwiftypeFacets', categoryCode], data).then(function (result) {
            const facets = {
                all: {},
                top: {},
            };

            angular.forEach(result.info[categoryCode].facets, function (facet, key) {
                // we only want to show inputs that have types we support
                var inputTypes = ['checkboxes', 'dropdown_checkboxes', 'range', 'textbox_dropdown'];
                if (inputTypes.indexOf(facet.input_type) > -1) {
                    facet.showInRefineResults = true;
                }

                facet.isMobileOpen = false;
                facet.isDesktopOpen = true;

                facet.code = key;
                if (facet.is_top_bar) {
                    facets.top[key] = facet;
                }
                facets.all[key] = facet;
            });

            setDefaultValues(facets);
            const facetInfo = {
                facets: facets,
                totalResultCount: result.info[categoryCode].total_result_count
            }
            _initialSwiftypeFacets = facetInfo;
            defer.resolve(facetInfo);
        }, function (result) {
            defer.reject({redirectTo: '404', reason: result});
        });

        return defer.promise;
    };


    /**
     * Takes the url encoded filters and converts them to an object that is
     * ready for swiftype. This function also sets initial filters.
     *
     * @param filters - url encoded string
     * @param categoryCode - code for currently active category
     * @param reset - whether or not to reset the filters
     * @param initializeFilters - whether or not to reinitialize the active filters
     * @returns {filters: {}}
     */
    _pub.convertInitialSwiftypeFilters = function(filters, categoryCode, reset=true, initializeFilters=true) {
        if (reset) {
            _pub.applyResetCallbacks();
        }
        var searchParams = {filters: {}};
        searchParams.filters[categoryCode] = {};

        let queryObj = null;
        if (filters) {
            queryObj = UtilService.queryParamsToDict(filters);
        }

        angular.forEach(_pub.defaultFilterSettings, function (defaultFilter, key) {
            let isFilterSelected = isDefaultFilterSelected(
                filters,
                defaultFilter.urlValue,
                defaultFilter.unselectedValue
            );
            if (isFilterSelected && defaultFilter.categoryCode === categoryCode) {
                let initialFacet = _pub.getInitialFacet(defaultFilter.urlValue);
                if (initialFacet) {
                    searchParams.filters[categoryCode][defaultFilter.code] = [initialFacet.display_name]
                }
            }
        });

        if (filters) {
            // translate filter keys first
            angular.forEach(queryObj, function (queryObjValue, queryObjKey) {
                if (_translatedCategoryFilters.hasOwnProperty(queryObjKey)) {
                    var newKey = _translatedCategoryFilters[queryObjKey];
                    if (newKey !== queryObjKey) {
                        queryObj[newKey] = queryObj[queryObjKey];
                        delete queryObj[queryObjKey];
                    }
                }
            });

            angular.forEach(queryObj, function (filterValue, filterKey) {

                var swiftypeValue = null,
                    initialFacet = _pub.getInitialFacet(filterKey);

                if (filterKey === 'query') {
                    searchParams.query = filterValue[0];
                } else if (initialFacet === null) {
                    $log.warn('URL filter ' + filterKey + ' not found in current facets.');
                } else {
                    var key = initialFacet.code;
                    if (initialFacet.input_type === 'range') {
                        // this is a range. we need to handle this one special.
                        swiftypeValue = _pub.convertRangeValueToSwiftype(initialFacet.url_value, queryObj);
                        searchParams.filters[categoryCode][initialFacet.code] = swiftypeValue;
                    } else {
                        swiftypeValue = _pub.convertValueToSwiftype(filterValue, initialFacet);
                        searchParams.filters[categoryCode][key] = swiftypeValue;
                    }
                }
            });
        }

        var initialFilters = angular.copy(searchParams.filters[categoryCode]);
        if ('query' in searchParams) {
            initialFilters.query = searchParams.query;
        }

        if (initializeFilters) {
            _pub.setFiltersInitialData(initialFilters);
        }

        var defaults = UtilService.getSiteSetting('default_swiftype_filters', {});
        if (categoryCode in defaults) {
            angular.merge(searchParams.filters[categoryCode], defaults[categoryCode]);
        }

        return searchParams;
    };

    /**
     * Builds display text for active filters to display on results.
     *
     * @returns {Array}
     */
    _pub.getActiveFilterTags = function() {
        var activeFilters = [];
        angular.forEach(_pub.initialFiltersData, function(filterValue, filterKey) {
            var initialFilter = _pub.getInitialFacet(filterKey);
            var activeFilter = {};
            if (filterKey === 'query') {
                activeFilter.key = filterKey;
                activeFilter.value = filterValue;
                activeFilter.display = '"' + filterValue + '"';
                activeFilters.push(activeFilter);
            } else if (Array.isArray(filterValue)) {
                filterValue.forEach(function(value) {
                    activeFilter = {};
                    activeFilter.key = filterKey;
                    activeFilter.value = value;
                    var title = initialFilter.display_name;
                    if (value.toLowerCase() === 'yes' || value === '1') {
                        activeFilter.display = title;
                    } else if (value.toLowerCase() === 'no') {
                        activeFilter.display = value + ' ' + title;
                    } else {
                        activeFilter.display = value;
                    }
                    activeFilters.push(activeFilter);
                });
            } else if (initialFilter.input_type === 'range') {
                activeFilter.key = filterKey;
                var max = filterValue.to || null;
                var min = filterValue.from || null;
                if (filterKey === 'price') {
                    max = $filter('toCurrency')(max);
                    min = $filter('toCurrency')(min);
                }
                activeFilter.value = filterValue;
                var units = initialFilter.units || '';
                if (min === null && max !== null) {
                    activeFilter.display = noMinText + ' ' + max + ' ' + units;
                } else if (min !== null && max !== null) {
                    activeFilter.display = min + ' - ' + max + ' ' + units;
                } else if (min !== null && max === null) {
                    activeFilter.display = min + ' ' + units + ' ' + noMaxText;
                }
                if (filterKey !== 'price') {
                    activeFilter.display = initialFilter.display_name + ': ' + activeFilter.display;
                }
                activeFilters.push(activeFilter);
            }
        });
        return activeFilters;
    };

    var sliceMinMax = function (value, index) {
        if (index === 0) {
            // we want to get the value without min_ or max_
            value = value.slice(4);
        } else {
            value = value.slice(0, index-1);
        }
        return value;
    };

    /**
     * Gets a single facet by key or url_value.
     *
     * @param key
     * @returns {*|null}
     */
    _pub.getInitialFacet = function (urlValue) {
        var initialFacet = null,
            minIndex = urlValue.indexOf('min-'),
            maxIndex = urlValue.indexOf('max-');

        if (minIndex > -1) {
            urlValue = sliceMinMax(urlValue, minIndex);
        }
        if (maxIndex > -1) {
            urlValue = sliceMinMax(urlValue, maxIndex);
        }
        const initialFacets = _initialSwiftypeFacets.facets;

        if (initialFacets.all.hasOwnProperty(urlValue)) {
            return initialFacets.all[urlValue];
        }
        angular.forEach(initialFacets.all, function(facet) {
            if (urlValue === facet.url_value) {
                initialFacet = facet;
            }
        });
        return initialFacet;
    };

    /**
     * Gets the results quantity based on the current state of the filters by making a swiftype search quantity call,
     * and sets the result quantity using the updateResultsQuantity which is defined in the controller level
     *
     */
    _pub.getResultsQuantity = () => {
        if (!_pub.isNewFiltersEnabled || !UtilService.isMobile()) {
            return;
        }
        const filterOutputsJson = getFilterOutputs();
        const filtersUrlFormatted = _pub.createLink(filterOutputsJson);

        const swiftypeFilters = _pub.convertInitialSwiftypeFilters(
            filtersUrlFormatted,
            _pub.activeCategory.category_code,
            false,
            false
        );
        const requestOptions = angular.extend({
            'filters': {},
            'document_types': [_pub.activeCategory.category_code],
        }, swiftypeFilters);

        SwiftypeService.fetchSearchQuantity(requestOptions).then((response) => {
            _pub.updateResultsQuantity(response.search_quantity);
        }).catch(function (error) {
            _pub.updateResultsQuantity(null);
            $log.error(error);
        });
    };

    _pub.getResultsOnChange = () => {
        if (_pub.isNewFiltersEnabled && UtilService.isMobile()) {
            setTimeout(() => {
                _pub.getResultsQuantity();
                runMobileFilterChangedCallbacks();
            });
        } else {
            if (_pub.isNewFiltersEnabled) {
                _pub.lockFilters = true;
            }
            setTimeout(_pub.filterResults);
        }
    };

    return _pub;

    /**
     * Determined whether or not we need to show the the default filter based on the query parameters
     *
     * @param filters {string} The url filers
     * @param urlValue {string} The url value of the filter
     * @param unselectedValue {string} The value of the unselected state of the filter
     * @return {boolean}
     */
    function isDefaultFilterSelected(filters, urlValue, unselectedValue) {
        let queryObj = null;
        if (filters) {
            queryObj = UtilService.queryParamsToDict(filters);
        }
        let shouldShowFilter = true;
        if (queryObj && queryObj.hasOwnProperty(urlValue)) {
            const value = queryObj[urlValue][0];
            if (value === unselectedValue) {
                shouldShowFilter = false;
            }
        }

        return shouldShowFilter;
    }

    /**
     * Sets the options of the default values
     *
     * @param facets {Object}
     */
    function setDefaultValues(facets) {
        for (const defaultFilterSetting of _pub.defaultFilterSettings) {
            if (facets.all.hasOwnProperty(defaultFilterSetting.code)) {
                facets.all[defaultFilterSetting.code]['values'] = defaultFilterSetting.options;
            }
        }
    }

    /**
     * Assures even the default filters are unselected if all filters are reset
     *
     * @return {string|null} The filter query to unselect default filters
     */
    function getUnselectedDefaultFilters() {
        let unselectedDefaultFilters = "";

        for (const filterCode in _pub.unselectedDefaultFilters) {
            const unselectedDefaultFilter = _pub.unselectedDefaultFilters[filterCode];
            const filterParam = filterCode + "=" + unselectedDefaultFilter;
            unselectedDefaultFilters += "&" + filterParam;
        }

        if (unselectedDefaultFilters === "") {
            return null;
        }

        return unselectedDefaultFilters.substr(1);
    }

    /**
     * Checks and applies auto toggles set in the filter_auto_toggles settings
     *
     * @param urlValue {string} The urlValue of the changed filter
     */
    function checkFilterAutoToggles(urlValue) {
        let facets = _initialSwiftypeFacets.facets.all;
        for (const filterAutoToggle of _pub.filterAutoToggles) {
            if (urlValue === filterAutoToggle.watch_url_value) {
                facets[filterAutoToggle.reset_filter_code].values.forEach(function (option) {
                    option.is_checked = false;
                });
            }
        }
    }

    /**
     * Gets the output of all filters and returns them inside an object
     *
     * @returns {Object} filter outputs mapping object from filter codes to values.
     * @example {
     *     price: {
     *         type: "range",
     *         max: 300
     *     },
     *     brand: ["honeywell"],
     *     color-category: ["gray"]
     * }
     */
    function getFilterOutputs() {
        let filterOutputs = {};
        _pub.filtersOutputCallbacks.forEach((filterOutput) => {
            const output = filterOutput.filter_output();
            const filterKey = Object.keys(output).pop();
            const filterValue = Object.values(output).pop();
            const filterKeyIsNew = !filterOutputs.hasOwnProperty(filterKey);

            if (filterKeyIsNew && filterValue !== null) {
                filterOutputs = angular.extend(filterOutputs, output);
            }
        });

        _cleanOffNullValues(filterOutputs);

        return filterOutputs;
    }

    /**
     * Returns the input type of the given filter
     *
     * @param filterDetails {Object} the details object of the filter
     *
     * @return {string} the input type of the given filter details object
     */
    function getFilterInputType (filterDetails) {
        for (const defaultFilterSetting of _pub.defaultFilterSettings) {
            if (filterDetails.code === defaultFilterSetting.code) {
                return "default_" + filterDetails.input_type;
            }
        }
        return filterDetails.input_type;
    }

    /**
     * Tracks the product filters engaged segment event
     *
     * @param filterOutput {Object} the output of the filter {'filter_code': {string|Object} filter_value}
     *
     */
    function trackProductFiltersEngaged (filterOutput) {
        AnalyticsService.reportEvent('Product Filters Engaged', {
            category: _pub.activeCategory.code,
            filter_key: Object.keys(filterOutput).pop(),
            filter_value: Object.values(filterOutput).pop()
        });
    }

    /**
     * Tracks the collapsed filters engaged segment event
     *
     */
    function trackCollapsedFiltersEngaged () {
        AnalyticsService.reportEvent('Collapsed Filters Engaged', {
            category: _pub.activeCategory.code,
        });
    }

    /**
     * Closes the new mobile filters
     */
    function closeMobileFilters() {
        $('.mobile-filters').removeClass('mobile-filters-visible');
        $('.mobile-filters-backdrop').removeClass('is-visible');
        $('body').removeClass('mobile-filters-open');
    }

    /**
     * Builds and returns the swiftype search request options based on the active filter and sortby options
     *
     */
    function getSwiftypeSearchRequestOptions() {
        const filterOutputsJson = getFilterOutputs();
        const filtersUrlFormatted = _pub.createLink(filterOutputsJson);

        const swiftypeFilters = _pub.convertInitialSwiftypeFilters(
            filtersUrlFormatted,
            _pub.activeCategory.category_code,
            false,
            true
        );

        let requestOptions = angular.extend({
            'filters': {},
            'document_types': [_pub.activeCategory.category_code],
        }, swiftypeFilters);

        const activeSortBy = FiltersSortByService.getActiveSortByOption();
        requestOptions = FiltersSortByService.getSwiftypeSort(activeSortBy, requestOptions, _pub.activeCategory.category_code);

        return requestOptions;
    }

}

module.exports = FiltersService;